import script from "./SubmissionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionDetail.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionDetail.vue?vue&type=style&index=0&id=460c53bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460c53bb"]])

export default __exports__